<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
                    <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
                      <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                        pluginspage="http://www.adobe.com/svg/viewer/install/" />
                      <span>NFO</span>
                    </a>
                  </li> -->
          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/focusedfund"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Focused Fund</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div>
        <div *ngIf="!IsMobile" class="SectionHeading">Focused Fund</div>
        <form autocomplete="off" [formGroup]="FocusedForm">
          <div>
            <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-3 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="AMC"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect1">
                    <option value="" disabled="true" selected>
                      Select AMC
                    </option>
                    <option
                      *ngFor="let AMC of SelectedAMC"
                      [value]="AMC.VALUEFIELD">
                      {{ AMC.TEXTFIELD }}
                    </option>
                  </select>
                  <label>AMC</label>
                </div>
              </div>

              <div class="col-md-3 col-sm-3 col-xs-3 InputBoxOuter">
                <button
                  class="CommonSubmitButton"
                  [disabled]="FocusedForm.value == '' || !FocusedForm.valid">
                  Add Fund
                </button>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="AMC"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect1">
                    <option value="" disabled="true" selected>
                      Select AMC
                    </option>
                    <option
                      *ngFor="let AMC of SelectedAMC"
                      [value]="AMC.VALUEFIELD">
                      {{ AMC.TEXTFIELD }}
                    </option>
                  </select>
                  <label>AMC</label>
                </div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-3 InputBoxOuter">
                <button
                  class="CommonSubmitButton"
                  [disabled]="FocusedForm.value == '' || !FocusedForm.valid">
                  Remove Fund
                </button>
              </div>
            </div>
          </div>
        </form>
        <div *ngIf="!IsMobile" class="tab-content pt-0 row paralleltb">
          <div id="AllFunds" class="tab-pane fade show active">
            <table id="ReportTable" class="CommonTable ClsReportTable w-100">
              <thead>
                <tr>
                  <th></th>
                  <th>Fund Name</th>
                  <th>1 Year return %</th>
                  <th>3 Year return %</th>
                  <th>5 Year return %</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let fund of FocusingFund">
                  <td>
                    <span><input type="radio" name="FocsuingFund" /></span>
                  </td>
                  <td>{{ fund.SchemeName }}</td>
                  <td>{{ fund.Oneyear }}</td>
                  <td>{{ fund.Threeyear }}</td>
                  <td>{{ fund.Fiveyear }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="vl"></div>
          <div id="Focused" class="tab-pane fade show active">
            <table id="ReportTable" class="CommonTable ClsReportTable w-100">
              <thead>
                <tr>
                  <th></th>
                  <th>Fund Name</th>
                  <th>1 Year return %</th>
                  <th>3 Year return %</th>
                  <th>5 Year return %</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let fund of FocusingFund">
                  <td>
                    <span><input type="radio" name="FocsuingFund" /></span>
                  </td>
                  <td>{{ fund.SchemeName }}</td>
                  <td>{{ fund.Oneyear }}</td>
                  <td>{{ fund.Threeyear }}</td>
                  <td>{{ fund.Fiveyear }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
